import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';
import { formatDateAndTime, inRn, mString } from 'lib/helpers/utility';

import Tag from 'components/shared/Tag/Tag';

export const TRANSACTIONS_TABLE_COLUMNS = (timezone) => [
  {
    headerName: 'Date',
    field: 'created_at',
    valueFormatter: ({ value }) => formatDateAndTime(value, timezone)
  },
  {
    headerName: 'Type',
    field: 'type',
    valueFormatter: ({ value }) => TYPE_LABELS[value] || value || '-'
  },
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: ({ value }) => <Tag size="small">{value}</Tag>
  },
  {
    headerName: 'Amount',
    field: 'amount_paid_self',
    valueFormatter: ({ data }) =>
      mString(inRn(data?.amount_paid_self) - inRn(data?.surcharge_amount))
  },
  {
    headerName: 'Tech. fee',
    field: 'surcharge_amount',
    valueFormatter: ({ value }) => mString(inRn(value, 0))
  },
  {
    headerName: 'Total',
    field: 'amount_total',
    valueFormatter: ({ data }) => mString(inRn(data?.amount_paid_self, 0))
  }
];
